/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleRecommendationPostponeRequest extends models.ScheduleRecommendationActionBaseRequest {
    getFixupPrototypeFunction() { return ScheduleRecommendationPostponeRequest.fixupPrototype; }

    static newInstance(model: Partial<ScheduleRecommendationPostponeRequest>): ScheduleRecommendationPostponeRequest {
        let obj = Object.assign(new ScheduleRecommendationPostponeRequest(), model);
        ScheduleRecommendationPostponeRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleRecommendationPostponeRequest>): ScheduleRecommendationPostponeRequest {
        if (!model) return null;
        return ScheduleRecommendationPostponeRequest.newInstance(<ScheduleRecommendationPostponeRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleRecommendationPostponeRequest) {
        if (!obj) return;

        models.ScheduleRecommendationPostponeRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleRecommendationPostponeRequest): boolean {
        if (models.ScheduleRecommendationActionBaseRequest.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleRecommendationPostponeRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.duration === undefined) {
            this.duration = 0;
        }
        if (this.potential_cost_savings_monthly === undefined) {
            this.potential_cost_savings_monthly = 0;
        }
        if (typeof this.from_time === "string") {
            this.from_time = new Date(<string><any>this.from_time);
        }
        if (typeof this.to_time === "string") {
            this.to_time = new Date(<string><any>this.to_time);
        }
    }

    /**
     * Duration of Delay to perform postpone
     */
    duration: number;

    /**
     * Unit for duration
     */
    unit: models.ScheduleRecommendationDurationUnit;

    /**
     * Email addresses to notify
     */
    emails: Array<string>;

    /**
     * Name of the resource component
     */
    resource_type: string;

    /**
     * Name of the resource
     */
    resource: string;

    day: models.DayOfWeek;

    /**
     * FromTime of the calculation
     */
    from_time: Date;

    /**
     * ToTime of the calculation
     */
    to_time: Date;

    /**
     * Monthly Cost Savings of the Recommendation
     */
    potential_cost_savings_monthly: number;

}
